<div class="logo" [ngClass]="color">
  <img class="logo-bluesail" [src]="'assets/images/bluesail-' + color + '.svg'" alt="BlueSail">
  <div class="logo-separator">
    <div class="logo-separator-element"></div>
  </div>
  <img class="logo-astound" [src]="'assets/images/astound-' + color + '.svg'" alt="Astound Commerce">
</div>
